document.addEventListener('DOMContentLoaded', function () {
  // Scroll-reveal: fade/slide elements in as they enter the viewport
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealTargets = document.querySelectorAll('.reveal');
  if (revealTargets.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach(function (el) { el.classList.add('in-view'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      revealTargets.forEach(function (el) { revealObserver.observe(el); });
    }
  }

  // FAQ accordion with smooth height animation (progressive enhancement over native <details>)
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var summary = item.querySelector('summary');
    var wrap = item.querySelector('.faq-answer-wrap');
    if (!summary || !wrap) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = item.hasAttribute('open');
      if (isOpen) {
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
        requestAnimationFrame(function () { wrap.style.maxHeight = '0px'; });
        wrap.addEventListener('transitionend', function handler() {
          item.removeAttribute('open');
          wrap.removeEventListener('transitionend', handler);
        }, { once: true });
      } else {
        item.setAttribute('open', '');
        wrap.style.maxHeight = '0px';
        requestAnimationFrame(function () { wrap.style.maxHeight = wrap.scrollHeight + 'px'; });
      }
    });
  });

  // Mobile nav toggle
  var toggle = document.querySelector('.mobile-nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // Product thumbnail swap
  document.querySelectorAll('.product-thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (mainImg && btn.dataset.fullSrc) {
        mainImg.src = btn.dataset.fullSrc;
        document.querySelectorAll('.product-thumb').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      }
    });
  });

  // Variant select -> update hidden variant id + price
  var optionSelects = document.querySelectorAll('.product-option-select');
  var variantIdSelect = document.querySelector('.product-variant-id');
  if (optionSelects.length && variantIdSelect) {
    function syncVariant() {
      var chosen = Array.from(optionSelects).map(function (s) { return s.value; });
      var match = Array.from(variantIdSelect.options).find(function (opt) {
        return opt.text.split(' / ').every(function (part, i) { return true; }) || true;
      });
      // Simple fallback: match by option title containing all chosen values
      var found = Array.from(variantIdSelect.options).find(function (opt) {
        return chosen.every(function (val) { return opt.text.indexOf(val) !== -1; });
      });
      if (found) {
        variantIdSelect.value = found.value;
        var priceEl = document.getElementById('ProductPrice');
        if (priceEl && found.dataset.price) {
          priceEl.innerHTML = '<span>' + found.dataset.price + '</span>';
        }
        var addBtn = document.querySelector('.btn-add-to-cart');
        if (addBtn) {
          var available = found.dataset.available === 'true';
          addBtn.disabled = !available;
          addBtn.textContent = available ? addBtn.dataset.labelAvailable || addBtn.textContent : 'Ausverkauft';
        }
      }
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', syncVariant); });
  }

  // Update cart count after add-to-cart via AJAX API (progressive enhancement)
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      var action = productForm.getAttribute('action') || '/cart/add';
      if (action.indexOf('/cart/add') === -1) return; // let normal submit happen
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEl = document.querySelector('[data-cart-count]');
          if (countEl) countEl.textContent = cart.item_count;
          window.location.href = '/cart';
        })
        .catch(function () { productForm.submit(); });
    });
  }
});
